<template>
  <div :class="{ 'checkbox-group-disabled': disabled, 'radio-group': true }">
    <div class="checkbox-title" v-if="title">
      {{ title }}
    </div>

    <div :class="['custom-radio-group', errorText ? 'radio-error' : '']">
      <div v-for="group in groupedSelectInfo" :key="group.value">
        <div
          v-if="group.items.length"
          style="color: #b18147; margin: 10px 0;"
        >
          {{ giftTitle(group.value) }}：
        </div>
        <div v-for="item in group.items" :key="item.text">
          {{ item.text }} (兌換點數：{{ item.value }} 點)

          <br />
          <div
            :class="[
              'select-number',
              item.count < 1 || disabled
                ? 'select-number-disabled'
                : 'select-number',
            ]"
            @click="item.count < 1 ? null : selectSub(item.text)"
          >
            -
          </div>
          {{ item.count }}
          <div
            :class="[
              'select-number',
              disabled || disabledAdd(item)
                ? 'select-number-disabled'
                : 'select-number',
            ]"
            @click="disabledAdd(item) ? null : selectAdd(item.text)"
          >
            +
          </div>
        </div>
      </div>

      <div class="error" v-if="errorText">{{ errorText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectNumButton",
  components: {},
  computed: {
    groupedSelectInfo() {
      if (!Array.isArray(this.selectInfo)) return [];

      const grouped = this.selectInfo.reduce((acc, item) => {
        const key = item.value;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      return Object.keys(grouped)
        .map((key) => Number(key))
        .sort((a, b) => a - b)
        .map((value) => ({
          value,
          items: grouped[value].slice().sort((a, b) => {
            const indexA = a.givewayIndex != null ? Number(a.givewayIndex) : 0;
            const indexB = b.givewayIndex != null ? Number(b.givewayIndex) : 0;
            return indexA - indexB;
          }),
        }));
    },
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    value: {},
    options: {
      type: Array,
    },
    errorText: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    giftPoints: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    value() {
      this.selectInfo = this.value;
    },
  },
  data() {
    return {
      selectInfo: [],
    };
  },
  mounted() {
    this.selectInfo = this.value;
    console.log(this.selectInfo);
  },
  methods: {
    giftTitle(value) {
      if (value === 1) return '點一盞燈可選贈';
      if (value === 2) return '點兩盞燈可選贈';
      if (value === 3) return '點三盞燈可選贈';
      return `點${value}盞燈可選贈`;
    },
    disabledAdd(item) {
      return item.value > this.giftPoints;
    },
    countClick() {
      this.$emit("input", this.selectInfo);
      this.$emit("countChange");
    },
    selectSub(key) {
      this.selectInfo.forEach((element) => {
        if (element.text == key) {
          element.count--;
          this.countClick();
        }
      });
    },
    selectAdd(key) {
      this.selectInfo.forEach((element) => {
        if (element.text == key) {
          element.count++;
          this.countClick();
        }
      });
    },
  },
};
</script>

<style>
.radio-group {
  min-height: 65px;
}

.checkbox-group-disabled > div:first-child {
  color: gray;
}

.custom-radio-group {
  margin: 0px;
  padding-left: 10px;
}

.radio-error {
  border-color: #c34040 !important;
  border: 1px solid rgba(70, 70, 70, 0.8);
  border-radius: 4px;
}

.checkbox-title {
  color: #b18147;
  font-size: 12px;
}

.select-number {
  margin: 20px;
  cursor: pointer;
  color: #b18147;
  font-size: 20px;
  display: inline;
}

.select-number-disabled {
  margin: 20px;
  cursor: default;
  color: gray;
  font-size: 20px;
  display: inline;
}

.custom-control {
  width: fit-content;
  cursor: pointer;
  padding: 0;
}
</style>
